interface BunnyStreamPlayerProps {
  embedUrl: string;
  autoplay?: boolean;
}

export default function BunnyStreamPlayer({
  embedUrl,
  autoplay = false,
}: BunnyStreamPlayerProps) {
  const src = autoplay
    ? `${embedUrl}?autoplay=true&preload=true&responsive=true`
    : `${embedUrl}?autoplay=false&preload=true&responsive=true`;

  return (
    <div style={{ position: "relative", paddingTop: "56.25%" }}>
      <iframe
        src={src}
        title="Video player"
        loading="lazy"
        style={{
          border: 0,
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        {...({
          webkitallowfullscreen: "true",
          mozallowfullscreen: "true",
        } as Record<string, string>)}
      />
    </div>
  );
}
